export const FieldType = {
	TEXT: 'text',
	ID: 'id',
	REFERENCE: 'reference',
	DATE: 'date',
	DATE_AGO: 'date_ago',
	EMAIL: 'email',
	AUTHOR: 'author',
	CODE: 'code',
	BOOLEAN: 'boolean',
	YES_NO: 'yes_no',
	SWITCH: 'switch',
	NUMBER: 'number',
	STATUS: 'status',
};

export type FieldType = (typeof FieldType)[keyof typeof FieldType];
